import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';
import { isNil } from 'lodash';

import {
  InputField,
  SelectField,
  ReduxFormButtonGroup,
} from 'Common/SemanticWrapper';
import { TitledCard } from 'Components/';
import { SC_SLP_FORM_NAME } from 'Common/FormEnum';
import { SCSLPFieldEnum as Fields } from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';
import { buildYearsFromFiscalYears } from 'Common/FormHelper';

import 'Styles/pages/mealequivalentsetup/mealequivalentstyle.less';

class SCSLPFormContainer extends Component {
  mealTypeOptions = [
    { value: 0, label: 'Breakfast' },
    { value: 1, label: 'Lunch' },
  ];

  monthOptions = [
    { key: 0, value: 1, text: '01' },
    { key: 1, value: 2, text: '02' },
    { key: 2, value: 3, text: '03' },
    { key: 3, value: 4, text: '04' },
    { key: 4, value: 5, text: '05' },
    { key: 5, value: 6, text: '06' },
    { key: 6, value: 7, text: '07' },
    { key: 7, value: 8, text: '08' },
    { key: 8, value: 9, text: '09' },
    { key: 9, value: 10, text: '10' },
    { key: 10, value: 11, text: '11' },
    { key: 11, value: 12, text: '12' },
  ];

  render() {
    const { loading, fiscalYears } = this.props;
    return (
      <Form name="SCSLP">
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <ReduxFormButtonGroup
                  label={'Meal Type'}
                  options={this.mealTypeOptions}
                  formName={SC_SLP_FORM_NAME}
                  fieldName={Fields.MealType}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  label={'Month'}
                  name={Fields.Month}
                  component={SelectField}
                  options={this.monthOptions}
                  loading={loading}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  label={'Year'}
                  loading={loading}
                  name={Fields.Year}
                  options={buildYearsFromFiscalYears(fiscalYears)}
                  component={SelectField}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  name={Fields.CompletedBy}
                  component={InputField}
                  label={'Completed By'}
                  loading={loading}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title={'Select Sites'}>
                  <Field component={SelectSitesTable} name={Fields.Sites} />
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (isNil(values[Fields.Month])) {
    errors[Fields.Month] = 'Month must be selected.';
  }
  if (
    isNil(values[Fields.Sites]) ||
    (Array.isArray(values[Fields.Sites]) && values[Fields.Sites].length === 0)
  ) {
    errors[Fields.Sites] = 'Please select at least one site.';
  }

  return errors;
};

export const SCSLPForm = reduxForm({
  form: SC_SLP_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(SCSLPFormContainer);



// WEBPACK FOOTER //
// ./src/pages/scslp/components/SCSLPForm.js